const tablewrap = '<div class="table-responsive" />'

function makeTablesResponsive () {
  $('table.ce-table').wrap(tablewrap)
}

if ($('table.ce-table').length > 0) {
  makeTablesResponsive();
}

if ($('.not-responsive table.ce-table').length > 0) {
  function makeTablesNotResponsive () {
    $('.not-responsive table.ce-table').unwrap('.table-responsive')
  }

  makeTablesNotResponsive();
}
